import UserRole from './UserRole';
import UserType from './UserType';
import Office from './Office';

export default class User {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
    type: UserType;
    role: UserRole;
    roles?: UserRole[];
    twoFactorEnabled: boolean;
    office: Office;
    manager: User;
    lmsNumber: number;
    defaultPayRate: number;
    accountDisabled: boolean;
}



// WEBPACK FOOTER //
// ./src/models/User.ts